import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import MainContainer from "pages/_components/MainContainer";
import CustomHead from "pages/_components/CustomHead";
import { actions as depositsActions } from "reducers/deposits";
import CustomText from "pages/_components/CustomText/CustomText";

const ForbidenCancelRenewalPage = () => {
    const { depositTicket } = useSelector((state) => state.deposits);
    const history = useHistory();
    const dispatch = useDispatch();
    const { id } = useParams();

    const handleBack = () => {
        dispatch(depositsActions.cleanDepositTicket());
        history.push(`/deposits/${id}/cancelRenewal`);
    };

    return (
        <>
            <CustomHead title="deposits.cancelAutoRenewal" onBack={handleBack} />
            <MainContainer showLoader={false}>
                <CustomText textType="STRING" text={depositTicket?.data?.message} />
            </MainContainer>
        </>
    );
};

export default ForbidenCancelRenewalPage;
